import {
    SET_FREEZE_BLOCK_FILTERS,
    GET_FREEZE_BLOCK_REPORT,
    CLEAR_FREEZE_BLOCK_REPORT,
} from '../actions/actionTypes';

const INITIAL_STATE = {
    freezeBlockFilters: {
        startDate: null,
        endDate: null,
        queryByField: 'gigyaId',
        queryByValue: '',
        promotionType: '',
    },
    freezeBlockReport: [],
    totalCount: 0,
    hasSearched: false,
    page: 0,
    rowsPerPage: 10,
};

const customerReportReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_FREEZE_BLOCK_FILTERS: {
            return {
                ...state,
                freezeBlockFilters: {
                    ...state.freezeBlockFilters,
                    ...action.filters,
                },
            };
        }
        case GET_FREEZE_BLOCK_REPORT: {
            return {
                ...state,
                freezeBlockReport: action.reportData,
                totalCount: action.totalCount,
                hasSearched: true,
            };
        }
        case CLEAR_FREEZE_BLOCK_REPORT: {
            return {
                ...INITIAL_STATE,
            };
        }
        default: {
            return state;
        }
    }
};

export default customerReportReducer;
